import initialState from '../store/initial-state'
import {
  ASSET_PUBLIC_SHARED_GET_DATA,
  ASSET_PUBLIC_SHARED_GET_DATA_SUCCESS,
  ASSET_PUBLIC_SHARED_GET_DATA_FAILURE,
  ASSET_PUBLIC_NAVIGATE_SHARED_DATA_SUCCESS,
  ASSET_PUBLIC_SHARED_EXPAND_SELECT,
  ASSET_PUBLIC_SHARED_EXPAND_UNSET_SELECT,
  PUBLIC_SHARED_SET_SELECT,
  PUBLIC_SHARED_UNSET_SELECT,
  PUBLIC_SHARED_ACTIVEVIEW,
  ASSET_HAS_PASSWORD,
  ASSET_HAS_PASSWORD_SUCCESS,
  ASSET_HAS_PASSWORD_FAILURE,
  ASSETS_PUBLIC_MULTI_DELETE,
  ASSETS_PUBLIC_MULTI_DELETE_SUCCESS,
  ASSETS_PUBLIC_MULTI_DELETE_FAILURE,
  ASSETS_PUBLIC_MULTI_MOVE,
  ASSETS_PUBLIC_MULTI_MOVE_SUCCESS,
  ASSETS_PUBLIC_MULTI_MOVE_FAILURE
} from '../constants/assets-public-shared-types'

export default (state = initialState.assetsPublicShared, action) => {
  switch (action.type) {
    case ASSET_PUBLIC_SHARED_GET_DATA:
      return {
        ...state,
        isFetching: true,
        data: [],
        headers: null,
        error: null,
        assetHasPassword: false,
        wrongPassword: false,
        accessToken: ''
      }

    case ASSET_PUBLIC_SHARED_GET_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
        headers: action.payload.headers,
        webToken: action.payload.webToken,
        nameSharedAsset: action.payload.nameSharedAsset,
        error: null
      }

    case ASSET_PUBLIC_SHARED_GET_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        data: [],
        headers: null,
        error: action.payload,
      }

    case ASSET_PUBLIC_NAVIGATE_SHARED_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
        headers: action.payload.headers,
        webToken: action.payload.webToken,
        accessToken: action.payload.accessToken,
        folderselect: action.payload.folderselect,
        nameSharedAsset: action.payload.nameSharedAsset,
        sharedBreadCrumb: action.payload.sharedBreadCrumb,
        page: action.payload.page,
        error: null
      }

    case ASSET_PUBLIC_SHARED_EXPAND_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isExpandSelected: r._id === action.payload.data._id,
          }
        })]
      }

    case ASSET_PUBLIC_SHARED_EXPAND_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isExpandSelected: false,
          }
        })]
      }

    case PUBLIC_SHARED_SET_SELECT:
      const maxItems = action.payload.from === 'vertical'
        ? action.payload.verticalCount
        : action.payload.horizontalCount
      let exist = false
      let count = 0

      return {
        ...state,
        data: [...state.data.map((r, k) => {
          let i = k + 1
          if (count >= maxItems) {
            count = 1
            exist = false
          } else {
            count++
          }
          if (!exist) exist = `${action.payload.from}-${i}` === action.payload.indice
          return {
            ...r,
            drawMiddleView: (exist && maxItems === count) || (exist && i === state.data.length),
            isSelected: r._id === action.payload.data._id,
            indice: r._id === action.payload.data._id
              ? action.payload.indice
              : null,
            from: r._id === action.payload.data._id
              ? action.payload.from
              : null
          }
        })]
      }

    case PUBLIC_SHARED_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            drawMiddleView: false,
            isSelected: false,
            isEditSelected: false,
            indice: null,
            from: null
          }
        })]
      }

    case PUBLIC_SHARED_ACTIVEVIEW:
      return {
        ...state,
        activeView: action.payload.activeView
      }

    case ASSET_HAS_PASSWORD:
      return {
        ...state,
        assetHasPassword: true,
        sharedBreadCrumb: []
      }

    case ASSET_HAS_PASSWORD_SUCCESS:
      return {
        ...state,
        assetHasPassword: false,
        accessToken: action.payload.accessToken,
        password: action.payload.password
      }

    case ASSET_HAS_PASSWORD_FAILURE:
      return {
        ...state,
        assetHasPassword: true,
        wrongPassword: true
      }
    case ASSETS_PUBLIC_MULTI_DELETE:
      return {
        ...state,
        isFetching: true
      }

    case ASSETS_PUBLIC_MULTI_DELETE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        workclient: action.payload.workclient,
        data: [...state.data.filter(r => !action.payload.ids.includes(r._id))],
        error: null
      }

    case ASSETS_PUBLIC_MULTI_DELETE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload.error
      }
    case ASSETS_PUBLIC_MULTI_MOVE:
      return {
        ...state,
        isMoving: true,
        headers: null,
        error: null
      }

    case ASSETS_PUBLIC_MULTI_MOVE_SUCCESS:
      return {
        ...state,
        isMoving: false,
        headers: action.payload.headers,
        data: [...state.data.map(r => {
          return {
            ...r,
            isMoveSelected: false,
            isMoved: action.payload.ids.includes(r._id),
          }
        })]
      }

    case ASSETS_PUBLIC_MULTI_MOVE_FAILURE:
      return {
        ...state,
        isMoving: false,
        headers: null,
        error: action.payload
      }

    default: return { ...state }
  }
}